<template>
  <div>
    <div class="total_infor">
      换针次数：{{counts1}}，换针数量：{{counts2}}
    </div>
    <div class="list-con">
      <el-table
        ref="filterTable"
        :data="tabelData"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <!-- <el-table-column type="selection" width="55" align="center"></el-table-column> -->
        <el-table-column
          :prop="item.key"
          :label="item.label"
          :width="item.key == 'image' ? '300' : (item.key == 'create_time' ? '145' : '125')"
          v-for="item in dataSource"
          :key="item.key"
		      align="center"
        >
          <template slot-scope="scope">
            <div
              class="text"
              v-if="item.key !== 'status_text' && item.key !== 'image' && item.key !== 'machine' && item.key !== 'department' && item.key !== 'user' && item.key !== 'create_time' && item.key !== 'code'"
            >
              {{ scope.row[item.key] }}
            </div>
            <div
              class="text"
              v-if="item.key == 'code'"
            >
              {{ getCodeText(scope.row[item.key]) }}
            </div>             
            <div
              class="text"
              v-if="item.key == 'department'"
            >
              {{ scope.row[item.key]["name"] }}
            </div>             
            <div
              class="text"
              v-if="item.key == 'create_time'"
            >
              {{ formatDate(scope.row[item.key]) }}
            </div>            
            <div
              class="text"
              v-if="item.key == 'user'"
            >
              {{ scope.row[item.key] ? scope.row[item.key]["nickname"] : '--' }}
            </div> 
            <div
              class="result"
              v-if="item.key == 'status_text'"
              :class="{ red: scope.row[item.key] == 1 }" 
              :style="'color:'+checkStatusColor(scope.row[item.key])+';'"
            >
              {{ scope.row[item.key] }}
            </div>
            <div v-if="item.key == 'image'" style="display: flex;justify-content: center;" @click="show_centerDialogVisible(scope.row)">
              <img style="height:80px;display:block;float:left;" :src="imgUrl+scope.row.image" alt="" />
              <!-- <img style="height:80px;display:block;float:left;" :src="imgUrl+scope.row.original_image" alt="" /> -->
            </div>
            <div
              v-if="item.key == 'menu'"
              class="tab-menu"
              style="cursor: pointer;justify-content: center;"
            >
              <div @click="upimg2(scope.row)" v-if="scope.row.status == 2 && scope.row.status_text == '强制换针'">上传签单表</div>
              <div @click="upimg4(scope.row)" v-if="scope.row.status_text == '换针中'">待审核</div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pages" style="display:block;height:auto;">
    <el-pagination
      background
      layout="prev, pager, next"
      :total="numdata"
      style="margin-top: 30px; float: right; margin-right: 60px"
      :current-page="current_page" 
      :page-size="page_size"
      @current-change="handleCurrentChange"
      @prev-click="handleCurrentChange_prev"
      @next-click="handleCurrentChange_next"
    >
    </el-pagination>
    </div>         
    <el-dialog
      title="查看图片"
      :visible.sync="centerDialogVisible"
      width="70%"
      center
      top="5vh"
    >
      <div style="margin-bottom:10px;overflow:hidden;text-align:center;">
      <img :src="centerDialogVisible_image" alt="" style="height:400px;display:inline-block;" />
      <img :src="centerDialogVisible_image2" alt="" style="height: 400px;display:inline-block;" />
      <div class="channel-size">标准值<br/>{{ centerSize }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="centerDialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="上传签单表"
      :visible.sync="upqiandan"
      width="40%"
      center
      top="5vh"
      @close="qdclose"
    >
      <div style="margin-bottom:10px;overflow:hidden;text-align:center;display: flex;align-items: center;justify-content: center;">
          <el-upload class="upload-demo" :action="headurl + loadurl" list-type="picture-card"
            :on-preview="handlePreview" multiple :show-file-list="false" :on-success="upsuccess">
            <div class="img_add_box">
              <div class="img_add_btn">
                <el-image class="img_add_icon" :src="imgAdd" fit="contain" />
              </div>
            </div>
          </el-upload>
          <div class="avater-img">
            <img :src="imgUrl + avater" />
          </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="upimg3"
          >确 定
        </el-button>
        <el-button type="primary" @click="upqiandan = false"
          >取 消
        </el-button>
      </span>
    </el-dialog>
    <el-dialog  title="换针矫正"
                :visible.sync="jiaozhen"
                width="20%"
                center
                top="5vh">
      <div>
        该针是否已成功取出？
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="changezen(1)"
          >成功取出
        </el-button>
        <el-button type="primary" @click="changezen(-1)"
          >未真实取针
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { changeNeedleHistory, postQiandan, changeStatus } from "../../api/index.js";

export default {
  props: {
    searchval: {
      type: String,
      default() {
        return "";
      },
    },
    searchtype: {
      type: String,
      default() {
        return "";
      },
    },
    approve: {
      type: [String, Number],
      default: ''
    }
  },  
  watch: {
    searchval(newValue, oldValue) {   
        if(newValue!=oldValue){
            this.current_page=1;
            this.getData();
        }
    },
    searchtype(newValue, oldValue) {   
        if(newValue!=oldValue){
            this.current_page=1;
            this.getData();
        }
    },
    approve(newValue, oldValue) {
      if(newValue!=oldValue){
        this.current_page=1;
        this.getData();
      }
    }
  },  
  data() {
    return {
      dataSource: [
        { label: "ID号", key: "id" },
        { label: "设备编号", key: "device_sn" },
        { label: "针名", key: "channel_name" },
        { label: "款号", key: "style_name" },
        { label: "所属生产组", key: "team_name" },
        { label: "员工生产组", key: "userteam_name" },
        { label: "机器编号", key: "machine_sn" },
        { label: "换针时间", key: "create_time" },
        { label: "更换人", key: "user" },
        { label: "更换结果", key: "status_text" },
        { label: "主管", key: "manager_name" },
        { label: "换针照片", key: "image" },
        { label: "异常情况", key: "code" },
        { label: "识别换针原因", key: "recognition_result" },
        { label: "标签", key: "part_name" },
        { label: "操作", key: "menu" },
      ],
      tabelData: [],
      editvisible: false,
      selectrow: {},
      slotmap: ["department","result", "menu","create_time", 'code'],
      centerDialogVisible: false,
      centerDialogVisible_image: "",
      centerDialogVisible_image2: "",
      imgUrl:"https://fmadmin.sewme.cn/",//图片网址
      counts1:0,//换针次数
      counts2:0,//换针数量
      numdata: 0,
      current_page: 1,
      page_size:5,    
      centerSize: 0,  
      upqiandan: false,
      headurl: "https://fmadmin.sewme.cn/index.php",
      loadurl: '/admin/ajax/upload',
      imgAdd: '',
      avater: '',
      secid: '',
      jiaozhen: false,
      seczhen: {}
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getCodeText(code) {
      if (!code) return '';
      const codeStr = String(code);
      if (codeStr.includes('A') || codeStr.includes('a')) {
        return '疑似牙签';
      } else if (codeStr.includes('B') || codeStr.includes('b')) {
        return '疑似铁丝';
      } else if (codeStr.includes('C') || codeStr.includes('c')) {
        return '其他异常';
      }
      return ''
    },
    getData(){
      let params={};
      if(this.searchval){
        if(this.searchtype){
          params={limit:this.page_size,page:this.current_page,
            "search[0][field]": "machine.sn",
            "search[0][val]": this.searchval,
            "search[0][operator]": "LIKE",  
            "search[1][field]": "create_time",
            "search[1][val]": this.searchtype,
            "search[1][operator]": "RANGE",  
            "search[1][render]": "datetime",  
          };
        }else{
          params={limit:this.page_size,page:this.current_page,
            "search[0][field]": "machine.sn",
            "search[0][val]": this.searchval,
            "search[0][operator]": "LIKE",   
          };
        }
      }else{
        if(this.searchtype){
          params={limit:this.page_size,page:this.current_page,
            "search[1][field]": "create_time",
            "search[1][val]": this.searchtype,
            "search[1][operator]": "RANGE",  
            "search[1][render]": "datetime",
          };
        }else{
          params={limit:this.page_size,page:this.current_page, 
          };
        }
      }
      if(this.approve !== 99) {
        params.is_approve = this.approve
      }
      changeNeedleHistory(params)
        .then((res) => {
          if (res.code == 1) {
            this.tabelData = res.data.list;
            this.numdata = res.data.total;
            this.counts1=res.data.change_total;
            this.counts2=res.data.needle_total;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    handleCurrentChange_next() {
      this.current_page += 1;
    },
    handleCurrentChange_prev() {
      this.current_page -= 1;
    },
    handleCurrentChange(val) {
      this.current_page=val;
      this.getData();
    },    
    formatDate(value) {// 时间戳转换日期格式方法
        if (value == null) {
            return '';
        } else {
            value=value*1000
            let date = new Date(value);
            let y = date.getFullYear();// 年
            let MM = date.getMonth() + 1;// 月
            MM = MM < 10 ? ('0' + MM) : MM;
            let d = date.getDate();// 日
            d = d < 10 ? ('0' + d) : d;
            let h = date.getHours();// 时
            h = h < 10 ? ('0' + h) : h;
            let m = date.getMinutes();// 分
            m = m < 10 ? ('0' + m) : m;
            let s = date.getSeconds();// 秒
            s = s < 10 ? ('0' + s) : s;
            // return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
			return y + '-' + MM + '-' + d + ' ' + h + ':' + m;
        }
    }, 
    checkStatusColor(val){
      var str="red";
      // if(val==1){
      //   str="#507af9";
      // }else if(val==2){
      //   str="#FD4D4E";
      // }else if(val==3){
      //   str="#606266";
      // }else if(val==4){
      //   str="#606266";
      // }
      if(val=='强制换针'){
        str="#507af9";
      }else {
        str="#606266";
      }
      return str;
    },        
    checkStatus(val){
      var str="待换针";
      if(val==1){
        str="成功更换";
      }else if(val==2){
        str="强制更换";
      }else if(val==3){
        str="更换失败";
      }else if(val==4){
        str="设置完成";
      }
      return str;
    },
    show_centerDialogVisible(row) {
      this.centerDialogVisible_image = this.imgUrl+row.image;
      this.centerDialogVisible_image2 = this.imgUrl+row.original_image;
      this.centerDialogVisible = true;
      this.centerSize = row.channel_size
      console.log('___channel_size', this.centerSize)
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    edit(item) {
      this.selectrow = item;
      this.editvisible = true;
    },
    itemdel() {},
    dialogclose() {
      this.editvisible = false;
    },
    upimg2(item) {
      this.secid = item.id
      if(item.signsheet_image) {
        this.avater = item.signsheet_image
      }
      this.upqiandan = true
    },
    handlePreview(file) {
      console.log(file);
    },
    upsuccess(e) {
      this.avater = e.data.file.url
    },
    imgupload(file) {
      console.log('___imgupload', file)
    },
    upimg3() {
      const params = {
        id: this.secid,
        signsheet_image: this.avater
      }
      postQiandan(params).then(res => {
        if(res.code == 1) {
          this.upqiandan = false
        }
      })
    },
    upimg4(item) {
      this.seczhen = item
      this.jiaozhen = true
    },
    qdclose() {
      this.avater = ''
    },
    changezen(status) {
      let params = {
        id: this.seczhen.id,
        status: status
      }
      changeStatus(params).then(res => {
        this.jiaozhen = false
        this.getData()
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.total_infor{display:block;width:98%;margin:0px auto;color:#4f77f3;font-size:15px;}
.list-con{padding-top:10px;width: 1600px;}
.tab-menu {
  display: flex;
  align-items: center;
  font-family: Source Han Sans CN;
  font-weight: 500;
  font-size: 14px;
  color: #507af9;
  column-gap: 13px;
  .line {
    width: 1px;
    height: 12px;
    background: #e6e6e6;
  }
  .edit {
    cursor: pointer;
  }
  .delbtn {
    cursor: pointer;
    color: #f95050;
  }
}
.result {
  color: #f95050;
  &.red {
    color: #507af9;
  }
}
.channel-size {
  position: absolute;
  right: 155px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 18px;
}
.avater-img {
  width: 250px;
  height: 250px;
  margin-left: 36px;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>